
import DOMPurify from "dompurify";

const CONFIG = {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["style", "form", "font"],
    FORBID_ATTR: ["style", "class"],
};

export default function limpiarHtml(html) {
    if (!html) return "";

    return DOMPurify.sanitize(String(html), CONFIG);
}
